import React, { useState } from 'react'
import LoginInput from '../../LoginInput';
import ShowPassword from './ShowPassword';
import InputQ from "../../FormComponents/InputQ/InputQ.jsx";

   const ViewPasswordButton = (props) => {
    const {locale,setNewPassword,newPassword,setError,error,loading,style,success,repeatNewPassword,setRepeatNewPassword,t,validationMessage,validationMessageN,validationMessageR} = props;

  
const [viewNewPassword, setViewNewPassword] = useState(false);
const [viewRepeatPassword, setViewRepeatPassword] = useState(false);

const toggleNewPasswordVisibility = () => {
  setViewNewPassword(!viewNewPassword);
};

const toggleRepeatPasswordVisibility = () => {
  setViewRepeatPassword(!viewRepeatPassword);
};

//Función para manejar cambios en la contraseña
const handleChangeNewPassword = (value) => {
  setNewPassword(value.target.value);
  error.type === "newPassword" &&
    setError({ message: "", type: null });
};
const handleChangeRepeatPassword = (value) => {
  setRepeatNewPassword(value.target.value);
  error.type === "repeatPassword" &&
    setError({ message: "", type: null });
};

  return (
    <>
        {!success && (
        <InputQ
          claro={true}
          // label={locale.form.input.newPassword}
          placeholder={locale.form.input.newPassword}
          hasPlaceholder={true}
          value={newPassword}
          // onChange={value => {
          //   setNewPassword(value);
          //   error.type === "newPassword" &&
          //     setError({ message: null, type: null });
          // }}
          type={viewNewPassword ? 'text' : 'password'}
          error={error.type === "newPassword" ? error.message : ""}
          disabled={loading || success}
          containerWidth={"100%"}
          containerMargin={"10px"}
          handleChange={handleChangeNewPassword}
          errorMessage={validationMessageN}
          additionalMessage={validationMessageN}
          additionalValidation={true}
          required={true}
          login={true}
          // additionalValidation={error.type === "newPassword" ? true : false}
          // additionalMessage={error.type === "newPassword" ? error.message : ""}
          // errorMessage={"This field is required"}
        />
      )}
      {/* <ShowPassword style={style.iconStyle1} parentCallback={toggleNewPasswordVisibility} /> */}
      {!success && (
        <InputQ
          claro={true}
          // label={locale.form.input.repeatNewPassword} 
          placeholder={locale.form.input.repeatNewPassword}
          hasPlaceholder={true}
          value={repeatNewPassword}
          // onChange={value => {
          //   setRepeatNewPassword(value);
          //   error.type === "repeatPassword" &&
          //     setError({ message: null, type: null });
          // }}
          type={viewRepeatPassword ? 'text' : 'password'}
          error={error.type === "repeatPassword" ? error.message : ""}
          disabled={loading || success}
          containerWidth={"100%"}
          containerMargin={"10px"}
          handleChange={handleChangeRepeatPassword}
          errorMessage={validationMessageR}
          required={true}
          login={true}
          additionalMessage={validationMessageR}
          additionalValidation={true}
          // additionalValidation={error.type === "repeatPassword" ? true : false}
          // additionalMessage={error.type === "repeatPassword" ? error.message : ""}
        />
      )}
        {/* <ShowPassword style={style.iconStyle2} parentCallback={toggleRepeatPasswordVisibility} /> */}
    </>
  )
}
export default ViewPasswordButton;